export default Object.freeze([
    {
        name: 'Vet practice',
        value: 'vet_address'
    },
    {
        name: 'Owner\'s home address ($50 additional charge)',
        value: 'customer_address'
    }
]);
